import { render } from "./LinkScan.vue?vue&type=template&id=8cf2076a&scoped=true"
import script from "./LinkScan.vue?vue&type=script&lang=ts"
export * from "./LinkScan.vue?vue&type=script&lang=ts"

import "./LinkScan.vue?vue&type=style&index=0&id=8cf2076a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8cf2076a"

export default script